//25 mm width
export const twentyMmOption = [
  { label: "80 rolls", rolls: 80, price: 2.24, boxCount: 1 },
  { label: "160 rolls", rolls: 160, price: 1.83, boxCount: 2 },
  { label: "240 rolls", rolls: 240, price: 1.58, boxCount: 3 },
  { label: "320 rolls", rolls: 320, price: 1.44, boxCount: 4 },
  { label: "400 rolls", rolls: 400, price: 1.34, boxCount: 5 },
  { label: "480 rolls", rolls: 480, price: 1.27, boxCount: 6 },
  { label: "560 rolls", rolls: 560, price: 1.2, boxCount: 7 },
  { label: "640 rolls", rolls: 640, price: 1.14, boxCount: 8 },
  { label: "720 rolls", rolls: 720, price: 1.11, boxCount: 9 },
  { label: "800 rolls", rolls: 800, price: 1.07, boxCount: 10 },
  { label: "880 rolls", rolls: 880, price: 1.06, boxCount: 11 },
  { label: "960 rolls", rolls: 960, price: 1.05, boxCount: 12 },
  { label: "1040 rolls", rolls: 1040, price: 1.04, boxCount: 13 },
  { label: "1120 rolls", rolls: 1120, price: 1.03, boxCount: 14 },
  { label: "1200 rolls", rolls: 1200, price: 1.0, boxCount: 15 },
]

//37.5 mm width
export const thirtySevenMmOption = [
  { label: "30 rolls", rolls: 30, price: 3.36, boxCount: 1 },
  { label: "60 rolls", rolls: 60, price: 2.74, boxCount: 2 },
  { label: "90 rolls", rolls: 90, price: 2.36, boxCount: 3 },
  { label: "120 rolls", rolls: 120, price: 2.16, boxCount: 4 },
  { label: "150 rolls", rolls: 150, price: 2.02, boxCount: 5 },
  { label: "180 rolls", rolls: 180, price: 1.91, boxCount: 6 },
  { label: "210 rolls", rolls: 210, price: 1.8, boxCount: 7 },
  { label: "240 rolls", rolls: 240, price: 1.72, boxCount: 8 },
  { label: "270 rolls", rolls: 270, price: 1.66, boxCount: 9 },
  { label: "300 rolls", rolls: 300, price: 1.6, boxCount: 10 },
  { label: "330 rolls", rolls: 330, price: 1.58, boxCount: 11 },
  { label: "360 rolls", rolls: 360, price: 1.57, boxCount: 12 },
  { label: "390 rolls", rolls: 390, price: 1.56, boxCount: 13 },
  { label: "420 rolls", rolls: 420, price: 1.55, boxCount: 14 },
  { label: "450 rolls", rolls: 450, price: 1.49, boxCount: 15 },
]

// 50 mm width
export const FiftyMmOptions = [
  { label: "40 rolls", rolls: 40, price: 4.48, boxCount: 1 },
  { label: "80 rolls", rolls: 80, price: 3.65, boxCount: 2 },
  { label: "120 rolls", rolls: 120, price: 3.15, boxCount: 3 },
  { label: "160 rolls", rolls: 160, price: 2.88, boxCount: 4 },
  { label: "200 rolls", rolls: 200, price: 2.69, boxCount: 5 },
  { label: "240 rolls", rolls: 240, price: 2.54, boxCount: 6 },
  { label: "280 rolls", rolls: 280, price: 2.4, boxCount: 7 },
  { label: "320 rolls", rolls: 320, price: 2.29, boxCount: 8 },
  { label: "360 rolls", rolls: 360, price: 2.21, boxCount: 9 },
  { label: "400 rolls", rolls: 400, price: 2.13, boxCount: 10 },
  { label: "440 rolls", rolls: 440, price: 2.11, boxCount: 11 },
  { label: "480 rolls", rolls: 480, price: 2.09, boxCount: 12 },
  { label: "520 rolls", rolls: 520, price: 2.08, boxCount: 13 },
  { label: "560 rolls", rolls: 560, price: 2.07, boxCount: 14 },
  { label: "600 rolls", rolls: 600, price: 1.99, boxCount: 15 },
  { label: "800 rolls", rolls: 800, price: 2.01, boxCount: 20 },
]

//75 mm width
export const seventyMmOption = [
  { label: "27 rolls", rolls: 27, price: 6.72, boxCount: 1 },
  { label: "53 rolls", rolls: 53, price: 5.48, boxCount: 2 },
  { label: "80 rolls", rolls: 80, price: 4.73, boxCount: 3 },
  { label: "107 rolls", rolls: 107, price: 4.32, boxCount: 4 },
  { label: "133 rolls", rolls: 133, price: 4.04, boxCount: 5 },
  { label: "160 rolls", rolls: 160, price: 3.81, boxCount: 6 },
  { label: "187 rolls", rolls: 187, price: 3.6, boxCount: 7 },
  { label: "213 rolls", rolls: 213, price: 3.44, boxCount: 8 },
  { label: "240 rolls", rolls: 240, price: 3.32, boxCount: 9 },
  { label: "267 rolls", rolls: 267, price: 3.2, boxCount: 10 },
  { label: "293 rolls", rolls: 293, price: 3.17, boxCount: 11 },
  { label: "320 rolls", rolls: 320, price: 3.14, boxCount: 12 },
  { label: "347 rolls", rolls: 347, price: 3.12, boxCount: 13 },
  { label: "373 rolls", rolls: 373, price: 3.11, boxCount: 14 },
  { label: "400 rolls", rolls: 400, price: 2.99, boxCount: 15 },
]

//150 mm width
export const hundredFiftyMmOption = [
  { label: "13 rolls", rolls: 13, price: 13.44, boxCount: 1 },
  { label: "27 rolls", rolls: 27, price: 10.95, boxCount: 2 },
  { label: "40 rolls", rolls: 40, price: 9.45, boxCount: 3 },
  { label: "53 rolls", rolls: 53, price: 8.64, boxCount: 4 },
  { label: "67 rolls", rolls: 67, price: 8.07, boxCount: 5 },
  { label: "80 rolls", rolls: 80, price: 7.62, boxCount: 6 },
  { label: "93 rolls", rolls: 93, price: 7.2, boxCount: 7 },
  { label: "107 rolls", rolls: 107, price: 6.87, boxCount: 8 },
  { label: "120 rolls", rolls: 120, price: 6.63, boxCount: 9 },
  { label: "133 rolls", rolls: 133, price: 6.39, boxCount: 10 },
  { label: "147 rolls", rolls: 147, price: 6.33, boxCount: 11 },
  { label: "160 rolls", rolls: 160, price: 6.27, boxCount: 12 },
  { label: "173 rolls", rolls: 173, price: 6.24, boxCount: 13 },
  { label: "187 rolls", rolls: 187, price: 6.21, boxCount: 14 },
  { label: "200 rolls", rolls: 200, price: 5.97, boxCount: 15 },
]

//150 mm width
export const twentyFiveNineHundredOption = [
  { label: "36 rolls", rolls: 36, price: 6.64, boxCount: 3 },
]
